import axios from 'axios';
import Cookies from 'js-cookie';

const apiRequest = async (endpoint, method = 'POST', body = null, params = {}) => {
    // Supported methods check
    const supportedMethods = ['GET', 'POST', 'PUT', 'DELETE'];
    if (!supportedMethods.includes(method)) {
        throw new Error(`Unsupported method: ${method}`);
    }

    const token = Cookies.get('farmerToken');
    const config = {
        method,
        url: endpoint,
        headers: {
            ...(token && endpoint !== '/' && { "token": token }),
        },
        ...(method === 'GET' ? { params } : { data: body }),
    };

    try {
        const response = await axios(config);
        return response.data;
    } catch (error) {
        if (error.response) {
            const { status, data } = error.response;

            if (status === 401) {
                // Token expired or invalid
                Cookies.remove('farmerToken');
                window.location.href = '/';
                return { status, message: data.message || "Invalid password or session expired" };
            }

            if (status === 404) {
                // User not found
                return { status, message: data.message || "User not found" };
            }

            console.error('API Error:', error.response);
            throw new Error(data.message || `API error: ${error.response.statusText}`);
        } else if (error.request) {
            console.error('No response from server:', error.request);
            throw new Error('No response from server. Please check your network connection.');
        } else {
            // General error
            console.error('API Request Error:', error.message);
            throw new Error('Something went wrong. Please try again.');
        }
    }
};

export { apiRequest };
